import { c as _c } from "react/compiler-runtime";
import { ReactNode } from "react";
type FormErrorTextProps = {
  children?: ReactNode;
};
export default function FormErrorText(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  const t1 = children ? children : "Invalid data";
  let t2;
  if ($[0] !== t1) {
    t2 = <p className="ml-1 text-sm text-red-500">{t1}</p>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  return t2;
}